import React, { lazy, Suspense } from "react";
import { useStyles } from "./styles";
import { Box, Container } from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";
import { useCheckinConstant } from "Hooks/checkin/useCheckinConstant";
import { LoadingWidget } from "Components/index";
const PageHeader = lazy(() => import("Components/PageHeader"));
const CheckinsDropdown = lazy(() => import("Modules/Checkins/Common/CheckinsDropDown"));
const TemplateList = lazy(() => import("Modules/Checkins/TemplateList"));
const CheckinAction = lazy(() => import("./CheckinAction"));

const Checkins = () => {
  const classes = useStyles();
  const { checkinTemplateDefaultValue } = useCheckinConstant();
  // const assignPeopleData = useRecoilValue(assignPeopleDataSelector);

  const methods = useForm({
    ...checkinTemplateDefaultValue,
    mode: "all",
  });

  return (
    <main className={`${classes.content} content-area`}>
      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" pageLoader={true} />
          </div>
        }
      >
        <FormProvider {...methods}>
          <Box flexGrow={1}>
            <PageHeader containerWidth="lg" title="Check-in Templates">
              <Box display="flex">
                <CheckinsDropdown name={"addCheckin"} />
              </Box>
            </PageHeader>
            <Container maxWidth="lg">
              <div className={classes.pageContent}>
                <TemplateList />
              </div>
            </Container>
          </Box>
          <CheckinAction name={"addCheckin"} />
        </FormProvider>
      </Suspense>
    </main>
  );
};
export default Checkins;
